<template>
  <el-container direction="vertical">
    
    <!-- 查询条件 -->
    <el-row style="height: 40px; line-height: 35px; border-radius: 4px; border: 1px solid #ccc; margin: 10px;" :gutter="10">
      <el-col :span="3">
        <el-input v-model="search.userName" placeholder="请输入姓名" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.mobile" placeholder="请输入手机号" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.cardNumber" placeholder="请输入身份证号" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.province" placeholder="请选择省份" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="(item, index) in globalData.provinceOptions" :key="index" :value="item.value" :label="item.text"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.type" placeholder="请选择作品类别" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option value="科普" label="科普"></el-option>
          <el-option value="科幻" label="科幻"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="search.school" placeholder="请输入学校名称" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      <el-col :span="3">
        <el-select v-model="search.nominate" placeholder="请选择推荐状态" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option value="0" label="未推荐"></el-option>
          <el-option value="1" label="预推荐"></el-option>
          <el-option value="2" label="待确定"></el-option>
          <el-option value="3" label="确认推荐"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
        <!-- <json-excel v-if="hasRole" :data="exportData" name='学生作品数据.csv' :beforeGenerate="beforeExport" type='csv' :fields='exportFields' style='display:inline-block;margin:0 10px'>
          <el-button type="warning" icon="el-icon-download">导出</el-button>
        </json-excel> -->
      </el-col>
    </el-row>

    <!-- 数据展示 -->
    <el-row style="flex: 1; background: #ccc; margin: 0 10px;">
      <el-table ref="tb" :data="page.list" height="100%" border style="width: 100%" v-loading="loading">
        <el-table-column prop="userName" label="姓名" width="75"></el-table-column>
        <el-table-column prop="province" label="省份" width="100"></el-table-column>
        <el-table-column prop="school" label="学校" min-width="150"></el-table-column>
        <el-table-column prop="grade" label="年级" min-width="80" align="center"></el-table-column>
        <el-table-column prop="title" label="作品标题" min-width="200"></el-table-column>
        <el-table-column prop="type" label="作品类别" min-width="80" align="center"></el-table-column>
        <el-table-column prop="readType" label="是否评阅" min-width="80" align="center"></el-table-column>
        <el-table-column prop="nominate" label="推荐状态" min-width="80" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewWork(scope.row)" >预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    
    <!-- 分页 -->
    <el-row style="border: 1px solid #aaa; box-sizing: border-box; background: #e1e1e1; margin: 0 10px 10px 10px; text-align: center;">
      <el-pagination background layout="prev, pager, next,total" :current-page="search.pageNum" :page-size="20" :total="page.total" @current-change="pageChange"></el-pagination>
    </el-row>

  </el-container>  
</template>

<script>
export default {
  computed: {
    hasRole() {
      let manager = this.globalData.manager
      let roles = this.globalData.exportRole
      return roles.includes(manager.id)
    }
  },
  data() {
    return {
      page: {},
      search: {
        pageNum: 1
      },
      exportFields: {
        '姓名':'student.userName',
        '性别':'student.gender',
        '手机号':'student.mobile',
        '身份证号':'student.cardNumber',
        '省份':'student.province',
        '城市':'student.city',
        '区县':'student.county',
        '学校':'student.school',
        '年级':'student.grade',
        '班级':'student.classNumber',
        '家长电话':'parentMobile',
        '作品类别':'type',
        '作品标题':'title',
        '提交时间':'createTime'
      },
      exportData:[],
      loading: true
    }
  },
  methods: {

    // 格式化审核状态
    mobileTypeFormatter(row, column, value) {
      if(parseInt(value) || false) {
        return '已验证'
      }else {
        return '待验证'
      }
    },

    // 格式化作品上传状态
    workIdFormatter(row, column, value) {
      if(parseInt(value) || false) {
        return '已上传'
      }else {
        return '未上传'
      }
    },

    // 分页显示数据
    pageChange(n) {
      this.loading=true
      this.loadData(n)
    },

    // 数据查询
    query() {
      this.loading=true
      this.loadData(1)
    },

    // 作品预览
    viewWork(row) {
      this.globalData.work = row
      this.$dialog.workViewer()
    },

    // 删除作品
    deleteWork(row){
      this.$confirm(`确定删除【${row.userName}】的作品吗？`,'提示').then(() => {
        this.api.works.deleteWork(`id=${row.id}`).then(msg => {
          this.$message.success(msg.data)
          this.loadData(this.search.pageNum)
        })
      }).catch(()=>{})
    },

    // 导出数据
    async beforeExport() {
      await this.api.works.queryList(this.search).then(res => {
        this.exportData = res.data
      })
    },

    // 加载数据
    loadData(n) {
      if(Object.keys(this.search).length > 0) {
        this.search.pageNum = n
        this.api.works.query(this.search).then(res => {
          this.page = res.data
          this.loading = false
          this.$refs.tb.bodyWrapper.scrollTop = 0;
        })
      }else {
        this.api.works.findPage(`pageNum=${n}`).then(res => {
          this.page = res.data
          this.loading = false
          this.$refs.tb.bodyWrapper.scrollTop = 0;
        })
      }      
    }
  },
  mounted() {
    this.loadData(1)
  }
}
</script>

